import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import { rem } from 'polished'
import media from '../../../utils/style'
import { Heading, Text, Image } from 'rebass'

export const VehiclePreviewWrapper = styled(Flex)`
  display: block;
  position: relative;
  z-index: 1;
  text-align: center;
`

export const VehiclePreviewBox = styled(Box)`
  display: block;
  position: relative;
  margin: 0 auto;
  cursor: pointer;
  a {
    text-decoration: none;
  }

  p,
  h4,
  span {
    transition: color 0.8s ${(props) => props.theme.ease.ease_out_circ};
  }
  h4,
  p > span {
    color: ${(props) => props.theme.colors.blue};
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: opacity 1.2s ${(props) => props.theme.ease.ease_out_circ};
    transition: background-color 1.2s
      ${(props) => props.theme.ease.ease_out_circ};
    opacity: 0;
    pointer-events: none;
  }

  &:hover {
    &:after {
      background-color: ${(props) => props.theme.colors.blue};
      opacity: 0.2;
    }
    border-radius: 6px;
    p {
      color: ${(props) => props.theme.colors.blue};
    }
    h4 {
      color: ${(props) => props.theme.colors.blue};
    }
  }
`

export const VehiclePrice = styled(Text)`
  color: ${(props) => props.theme.colors.blue};
  line-height: 1.3;
  & > span::before {
    content: ' | ';
    display: inline-block;
    padding: 0 10px;
  }
  & > span:first-child::before {
    content: normal;
  }
`

export const CardHeading = styled(Heading)`
  color: ${(props) => props.theme.colors.blue};
  & > span::before {
    content: ' | ';
    display: inline-block;
    padding: 0 10px;
    color: ${(props) => props.theme.colors.grey_light};
  }
  & > span:first-child::before {
    content: normal;
  }
`

export const VehicleImage = styled(Image)`
  width: 100%;
  ${media.MediumScreenUp`
  min-width: ${rem(200)}
  `}
`

export const Callout = styled(({ ...rest }) => <a {...rest} />)`
  position: absolute;
  right: 50px;
`
